<template>
    <console-layout width="100%" max-width="1600">

        <console-title>
            <span>EBook 업체 목록</span>
        </console-title>

        <console-body>
            <v-data-table :loading="loading" :items="ebookCompanies" :headers="ebookCompaniesHeaders" hide-default-footer disable-sort class="elevation-1">
                <template v-slot:[`item.phone`]="{item}">
                    <span v-if="item.phone">{{ item.phone.phoneNumberFormat() }}</span>
                    <span v-else>-</span>
                </template>
                <template v-slot:[`item.isAutoBlock`]="{item}">
                    <v-switch v-model="item.isAutoBlock" :disabled="!$hasScope(['root', 'admin'])" hide-details class="pa-0 ma-0 d-inline-block" color="red lighten-2" @change="update({ _id: item._id, isAutoBlock: item.isAutoBlock })"/>
                </template>
                <template v-slot:[`item.isBlock`]="{item}">
                    <v-switch v-model="item.isBlock" :disabled="!$hasScope(['root', 'admin'])" hide-details class="pa-0 ma-0 d-inline-block" color="red lighten-2" @change="update({ _id: item._id, isBlock: item.isBlock })"/>
                </template>
                <template v-slot:[`item.isDormancy`]="{item}">
                    <v-switch v-model="item.isDormancy" :disabled="!$hasScope(['root', 'admin'])" hide-details class="pa-0 ma-0 d-inline-block" color="red lighten-2" @change="update({ _id: item._id, isDormancy: item.isDormancy })"/>
                </template>
                <template v-slot:[`item.actions`]="{item}">
                    <v-icon small @click="edit(item)">mdi-pencil</v-icon>
                    <v-icon small class="ml-3" @click="remove(item)">mdi-delete</v-icon>
                </template>
                <template #[`item.cash`]="{item}">{{ item.cash.format() }}</template>
                <template #[`item.point`]="{item}">{{ item.point.format() }}</template>
                <template #[`item.loginFailedCount`]="{item}">
                    {{ item.loginFailedCount[$dayjs().format("YYYY-MM-DD")] || 0 }} / 5
                    <v-icon small @click="update({ _id: item._id, loginFailedCount: new Map() }); item.loginFailedCount = {};">mdi-refresh</v-icon>
                </template>
                <template #[`item.createdAt`]="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD") }}</template>
                <template #[`item.visitedAt`]="{item}">{{ $dayjs(item.visitedAt).format("YYYY-MM-DD HH:mm:ss") }}</template>
            </v-data-table>
        </console-body>


        <v-dialog v-if="$hasScope(['root', 'admin'])" v-model="dialog" max-width="500">
            <template #[`activator`]="{on}">
                <v-btn v-on="on" color="accent" elevation="4" fab fixed right bottom><v-icon>mdi-pencil</v-icon></v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <span class="subtitle-1"><b>{{ !editItem?._id ? `업체 등록` : `업체 수정` }}</b></span>
                </v-card-title>

                <v-card-text>
                    <div>
                        <div class="caption"><b>아이디<font color="red"> *</font></b></div>
                        <v-text-field v-model="editItem.username" outlined dense hide-details />
                    </div>
                    <div class="mt-4">
                        <div class="caption"><b>비밀번호<font v-if="!editItem._id" color="red"> *</font></b></b></div>
                        <v-text-field v-model="editItem.password" type="password" outlined dense hide-details />
                    </div>
                    <div class="mt-4">
                        <div class="caption"><b>업체명<font color="red"> *</font></b></b></div>
                        <v-text-field v-model="editItem.name" outlined dense hide-details />
                    </div>
                    <div class="mt-4">
                        <div class="caption"><b>연락처</b></div>
                        <v-text-field v-model="editItem.phone" outlined dense hide-details />
                    </div>
                    <div class="mt-4">
                        <div class="caption"><b>수수료<font color="red"> *</font></b></b></div>
                        <v-text-field v-model="editItem.commission" type="number" outlined dense hide-details />
                    </div>
                    <div class="mt-4">
                        <div class="caption"><b>자동차단안함/자동차단</b></div>
                        <v-switch v-model="editItem.isAutoBlock" dense hide-details class="mt-0" />
                    </div>
                    <div class="mt-4">
                        <div class="caption"><b>관리자차단안함/관리자차단</b></div>
                        <v-switch v-model="editItem.isBlock" dense hide-details class="mt-0" />
                    </div>
                    <div class="mt-4">
                        <div class="caption"><b>휴면안함/휴면</b></div>
                        <v-switch v-model="editItem.isDormancy" dense hide-details class="mt-0" />
                    </div>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-btn color="primary" class="ml-auto" @click="save()">저장</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import { mdiMicrosoftExcel, mdiPlusCircleMultipleOutline, mdiRefresh, mdiAlertCircleOutline } from "@mdi/js";
import CryptoAES from '@/plugins/crypto-aes';

export default {
    components: {
        VDateField
    },
    data(){
        return {
            mdiRefresh,
            mdiMicrosoftExcel,
            mdiPlusCircleMultipleOutline,
            mdiAlertCircleOutline,

            loading: true,
            summary: { totalCount: 0 },

            ebookCompanies: [],
            ebookCompaniesHeaders: [
                { text: "아이디", value: "username", align: "center", width: 100 },
                { text: "업체명", value: "name", align: "center", width: 110 },
                { text: "연락처", value: "phone", align: "center", width: 150 },
                { text: "수수료", value: "commission", align: "center", width: 100 },
                { text: "로그인 실패횟수", value: "loginFailedCount", align: "center", width: 100 },
                { text: "자동차단안함 / 자동차단", value: "isAutoBlock", align: "center", width: 80 },
                { text: "관리자차단안함 / 관리자차단", value: "isBlock", align: "center", width: 80 },
                { text: "휴면안함 / 휴면", value: "isDormancy", align: "center", width: 80 },
                { text: "방문수", value: "visitedCount", align: "center", width: 90 },
                { text: "등록일자", value: "createdAt", align: "center", width: 120 },
                { text: "접속일자", value: "visitedAt", align: "center", width: 120 },
                { text: "최근접속IP", value: "visitedIp", align: "center", width: 100 },
                ...(this.$hasScope(['root', 'admin']) ? [{ text: "actions", value: "actions", align: "center", width: 100 }] : []),
            ],

            editItem: {},
            dialog: false
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.search();
            this.clear();
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            this.loading = true;
            this.members = [];
            let { summary, ebookCompanies } = await api.console.user.ebookCompanies.gets({
                headers: {
                    skip: 0,
                    limit: 0
                },
                params: this.filter
            });

            this.loading = false;
            this.summary = summary;
            this.ebookCompanies = ebookCompanies;
        },

        edit(ebookCompany){
            this.editItem = ebookCompany;
            this.dialog = true;
        },

        clear(){
            this.editItem = {
                username: null,
                password: null,
                name: null,
                phone: null,
                commission: 0,
                isAutoBlock: false,
                isBlock: false,
                isDormancy: false,
            }
        },

        validate(){
            try{
                if(!this.editItem.username) throw new Error("아이디를 입력해주세요");
                if(!this.editItem.password && !this.editItem._id) throw new Error("비밀번호를 입력해주세요");
                if(!this.editItem.name) throw new Error("업체명을 입력해주세요");

                return true;
            }
            catch(error){
                alert(error.message);
                return false;
            }
        },

        async save(){
            let ebookCompany = this.editItem;

            if(this.validate()){
                await api.console.user.ebookCompanies[ebookCompany._id ? `put` : `post`]({
                    ...ebookCompany,
                    password: ebookCompany.password ? CryptoAES.encrypt(ebookCompany.password) : undefined
                });
    
                alert("저장되었습니다");
                await this.search();
                this.dialog = false;
            }
        },

        async remove(ebookCompany){
            if(confirm("삭제 하시겠습니까?")){
                await api.console.user.ebookCompanies.delete(ebookCompany);
                this.search();
            }
        },
    }
}
</script>